import { useEffect } from 'react';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import { useIsFromArchitrave } from './useIsFromArchitrave';
import { buildArtistPageTitle, buildArtistSearchName } from '../util/artistSeoText';


export const useTitle = () => {
  const { setting } = useSetting();
  const isFromArchitrave = useIsFromArchitrave();

  useEffect(() => {
    if (isFromArchitrave) {
      document.title = "Architrave";
      return;
    }
    if (!setting || setting.username === "") {
      document.title = "Architrave";
    } else {
      const searchName = buildArtistSearchName(
        setting.seo.name,
        setting.seo.nameEn,
        setting.username
      );
      document.title = buildArtistPageTitle(searchName);
    }
  }, [setting, isFromArchitrave]);
}
